import antdTheme from "@/styles/antdTheme";
import novaTheme from "@/styles/novaTheme";
import { ThemeProvider } from "@emotion/react";
import { ConfigProvider } from "antd";
import "antd/dist/reset.css";
import type { ReactNode } from "react";

export const StyleProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ConfigProvider theme={antdTheme}>
      <ThemeProvider theme={novaTheme}>{children}</ThemeProvider>
    </ConfigProvider>
  );
};
